<template>
  <div class="g-table">
    <el-table
      id="dailyworkTable"
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      height="100%"
      border
      @selection-change="selectionChange"
      :row-style="{height:'30'}"
      :row-class-name="tableRowClassName"
    >
      <!-- check-->
      <el-table-column align="center" type="selection" width="34" :selectable="jinzhi"></el-table-column>
      <!-- 姓名 -->
      <el-table-column align="center" label="姓名" min-width="110">
        <template slot-scope="scope">
          <div>{{ typeof scope.row.rycn == 'undefined'? scope.row.employee_id : scope.row.rycn}}</div>
        </template>
      </el-table-column>
      <!-- 项目名称 -->
      <el-table-column align="center" label="项目名称" prop="project_name_cn" min-width="180">
        <template slot-scope="scope">
          <div>{{ typeof scope.row.xiangmucn == 'undefined'? scope.row.project_id : scope.row.xiangmucn }}</div>
        </template>
      </el-table-column>
      <!-- 阶段任务 -->
      <el-table-column align="center" label="阶段任务" min-width="380%">
        <template slot-scope="scope">
          <div>{{scope.row.task_name_str}}</div>
        </template>
      </el-table-column>
      <!-- 工作时长 -->
      <el-table-column align="center" label="加班时长(H:M)" width="120%">
        <template slot-scope="scope" class="elTable">
          <table frame="void" v-if="scope.row.is_confirmed == 0 && CtimeFlag == 'open'">
            <tr>
              <td>
                <el-input v-model="scope.row.show_hour" size="small" @change="update(scope.$index)"></el-input>
              </td>
              <td>
                <el-input v-model="scope.row.show_min" size="small" @change="update(scope.$index)"></el-input>
              </td>
            </tr>
          </table>
          <div v-else>{{scope.row.show_hour + ":" + scope.row.show_min}}</div>
        </template>
      </el-table-column>
      <!-- 工作内容 -->
      <el-table-column align="center" label="加班内容" width="400%">
        <template slot-scope="scope">
          <div>{{scope.row.comments}}</div>
        </template>
      </el-table-column>
      <!-- 操作 -->
      <el-table-column align="center" label="操作" width="130%" v-if="CtimeFlag == 'open'">
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            size="mini"
            @click="tablebianji(scope.$index,scope.row,1)"
            v-show="scope.row.is_confirmed == 0"
          >
            <span class="edit-btn">确认通过</span>
          </el-button>
          <el-button
            type="danger"
            plain
            size="mini"
            @click="tablebianji(scope.$index,scope.row,0)"
            v-show="scope.row.is_confirmed == 1"
            style="margin-left:0;"
          >
            <span class="edit-btn">取消通过</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getBaseInfo, getPerson } from "@/api/user";
import { hourToMin, myGrounpX } from "@/lib/until";
import { showLoading, hideLoading } from "@/lib/loading";
export default {
  name: "GetTable",
  data() {
    return {
      base_info: [], //基础列表
      depart_id: "", //部门id
      personId: "", //人员id
      password: "",
      getdataxm: "", //人员姓名
      getdataId: "",
      options: [] //项目阶段
    };
  },
  props: {
    CtableData: {
      type: Array,
      default: []
    },
    CtimeFlag: {
      type: String,
      default: ""
    }
  },
  created() {
    this.getuserInfo();
    this.getTableData();
  },
  computed: {
    tableData() {
      return this.CtableData;
    }
  },
  methods: {
    //单行确认通过
    tablebianji(index, row, flag) {
      let sendObj = {};
      if (flag == 1) {
        row.is_confirmed = 1;
        sendObj.is_confirmed = 1;
      } else if (flag == 0) {
        row.is_confirmed = 0;
        sendObj.is_confirmed = 0;
      } else {
        return;
      }
      sendObj.overtime_report_id = this.tableData[index].overtime_report_id;
      this.$http
        .post(
          IPConfig.IP + "/kpi-management/overtimereport/update.php",
          JSON.stringify(sendObj),
          { emulateJSON: true }
        )
        .then();
    },
    tableRowClassName({ row, rowIndex }) {
      //console.log(row);
      if (row.colorTag === 1) {
        return "warning-row";
      } else if (row.colorTag === 2) {
        return "success-row";
      }
      return "";
    },

    getuserInfo() {
      var uesrInfo = JSON.parse(localStorage.getItem("uesrInfo"));
      this.depart_id = uesrInfo.depart_ID;
      this.personId = uesrInfo.employee_id;
      this.password = uesrInfo.password;
      //console.log(this.depart_id);
    },
    //禁止复选框选中
    jinzhi(row, index) {
      return row.is_confirmed == 0;
      //打开编辑页面
    },
    getTableData() {
      getBaseInfo().then(data => {
        //console.log(this.depart_id);
        this.base_info = data;

        getPerson(this.depart_id).then(data => {
          //console.log(data);
          this.getDepartAndProjectData = data;
          let jieduan = this.getDepartAndProjectData;
          let baseInfo = this.base_info;
          this.$emit("getdata", jieduan, baseInfo);
        });
      });
    },
    getOptionOfTask(task) {
      var temp = {
        value: task.task_id,
        label: task.task_abbr + "." + task.task_name_cn
      };
      var subtaskkeys = Object.keys(task.sub_task);
      for (var i = 0; i < subtaskkeys.length; i++) {
        if (i == 0) {
          temp.children = [];
        }

        temp.children.push(this.getOptionOfTask(task.sub_task[subtaskkeys[i]]));
      }

      ////console.log(temp);
      return temp;
    },
    //提交数据
    update(index) {
      var Msg = this.tableData[index];
      this.checkInput(Msg);
      //console.log(Msg.depart_id);
      Msg.overtime_report_date = this.$root.Time;
      //phase-id与project-id
      if (Msg.overtime_report_id != -1) {
        this.$http
          .post(
            IPConfig.IP + "/kpi-management/overtimereport/update.php",
            JSON.stringify(this.updateJSONmsg(Msg)),
            { emulateJSON: true }
          )
          .then();
      } else if (
        Msg.employee_id != "" &&
        Msg.project_id != "" &&
        Msg.value1.length != 0 &&
        Msg.comments != "" &&
        Msg.show_hour != "" &&
        Msg.show_min != ""
      ) {
        //console.log("获取")
        var addMsg = this.updateJSONmsg(Msg);
        this.$http
          .post(
            IPConfig.IP + "/kpi-management/overtimereport/create.php",
            JSON.stringify(addMsg),
            { emulateJSON: true }
          )
          .then(function(res) {
            var getovertime_report_id = res.body;
            addMsg.overtime_report_id =
              getovertime_report_id.overtime_report_id;
            //console.log(getDaily_report_id.daily_report_id);
            this.$http
              .post(
                IPConfig.IP + "/kpi-management/overtimereport/update.php",
                JSON.stringify(addMsg),
                { emulateJSON: true }
              )
              .then(function(res) {
                //console.log(res.body);
              });
          });
      }
      //console.log("this.tableData", this.tableData);
    },
    checkInput(vms) {
      if (isNaN(Number(vms.show_hour))) {
        vms.show_hour = "0";
      }
      var tempMin = Number(vms.show_min);
      if (isNaN(tempMin) || tempMin < 0) {
        vms.show_min = "0";
      } else if (tempMin > 59) {
        vms.show_min = "59";
      }
    },
    getEmployeeWorkHoursSum(employee_id) {
      var sum = 0;
      for (var i = 0; i < this.tableData.length; i++) {
        if (employee_id == this.tableData[i].employee_id) {
          sum += Number(this.tableData[i].work_hour);
        }
      }
      return sum;
    },
    minToHour(vms) {
      //work_hour格式化
      var hourvalue = Number(vms.show_hour) + Number(vms.show_min) / 60;
      vms.work_hour = String(hourvalue.toFixed(3));
    },
    updateJSONmsg(updateMsg) {
      if (updateMsg.value1.length == 3) {
        updateMsg.task_id = updateMsg.value1[2];
        updateMsg.phase_id = updateMsg.value1[0];
      }
      if (updateMsg.value1.length == 2) {
        updateMsg.task_id = updateMsg.value1[1];
        updateMsg.phase_id = updateMsg.value1[0];
      }
      this.minToHour(updateMsg);
      //转成JSON数据
      return updateMsg;
      //发送数据
    },

    formatter(row, column) {
      //console.log(row.employee_id);
      if (row.employee_id == this.getdataId) {
        //console.log(this.getdataxm);
        return this.getdataxm;
      }
      // return row.address;
    },

    // //生成excel表格
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    exportToExcel() {
      var printdailyworktable = [];
      printdailyworktable = this.getHeadername();

      //console.log(printdailyworktable);
      require.ensure([], () => {
        const { export_json_to_excel } = require("../../vendor/Export2Excel");
        const tHeader = [
          "日期",
          "姓名",
          "阶段所属部门",
          "项目",
          "项目阶段",
          "加班时长",
          "工作内容"
        ];
        const filterVal = [
          "date",
          "name",
          "depart",
          "project",
          "phase_task",
          "work_hour",
          "comments"
        ];
        const list = printdailyworktable;
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "加班列表_" + this.$root.Time);
      });
    },
    getHeadername() {
      //console.log(this.tableData);
      var printTabledata = [];
      var exceltablerowdata = {
        date: "",
        name: "",
        depart: "",
        project: "",
        phase_task: "",
        work_hour: "",
        comments: ""
      };

      //获取id对应的中文名称
      for (var i = 0; i < this.tableData.length; i++) {
        let tablerowdata = Object.assign({}, exceltablerowdata);
        for (var key in this.base_info.project_list) {
          //console.log(key);
          if (this.tableData[i].project_id == key) {
            tablerowdata.project = this.base_info.project_list[
              key
            ].project_name_cn;
          }
        }
        tablerowdata.depart = this.tableData[i].bumencn;
        tablerowdata.phase_task = this.tableData[i].task_name_str;
        tablerowdata.work_hour = this.tableData[i].work_hour;
        tablerowdata.comments = this.tableData[i].comments;
        tablerowdata.date = this.$root.Time;
        tablerowdata.name = this.tableData[i].rycn;
        //console.log(tablerowdata);
        printTabledata.push(tablerowdata);
        tablerowdata = {};
      }
      // console.log(printTabledata);
      return printTabledata;
    },

    selectionChange(selection) {
      this.checked = selection;
    },
    //全部通过
    allpass() {
      //console.log(this.checked);
      if (this.checked == undefined) {
        alert("至少先选择一条数据");
        return;
      }
      this.$confirm("确定全部通过吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "全部通过!",
            duration: "500"
          });
          //console.log(this.checked);
          var update_report_list = {
            update_report_list: []
          };
          this.checked.forEach(function(value) {
            // console.log(value);
            var deleterowReportID = {
              // "is_confirmed": 1
            };
            value.is_confirmed = 1;
            deleterowReportID.overtime_report_id = Number(
              value.overtime_report_id
            );
            deleterowReportID.is_confirmed = value.is_confirmed;
            //console.log(deleterowReportID.daily_report_id);
            update_report_list.update_report_list.push(deleterowReportID);
          }, this);

          this.$http
            .post(
              IPConfig.IP + "/kpi-management/overtimereport/update.php",
              JSON.stringify(update_report_list),
              { emulateJSON: true }
            )
            .then();
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="less">
.g-table {
  margin-top: 20px;
}
.page-title {
  font-size: 32px;
  text-align: left;
  font-weight: bold;
  margin-bottom: 10px;
}
.breadcrumb {
  background-color: white;
  padding: 0.5rem;
  margin-bottom: 25px;
}
.table-container {
  border: 1px solid blue;
}
.form-container {
  padding: 10px;
}
.form-title {
  background-color: blue;
  color: white;
  padding: 0.5rem;
  text-align: left;
  margin-bottom: 5px;
}
.btn-container {
  overflow: hidden;
  .el-button {
    float: left;
  }
}
.search-input {
  width: 300px;
  float: left;
  margin-left: 10px;
  margin-right: 5px;
}
.el-table__body {
  td {
    padding: 0;
  }
}

.titleBumen {
  width: 140px !important;
  margin-left: 20px !important;
  color: red !important;
}
</style>


// WEBPACK FOOTER //
// src/views/Examine/GetTable.vue